import React, { Component } from "react";
import Lightbox from "react-image-lightbox";

import image1 from "../../../img/szatnia/Galeria1.jpg";
import image2 from "../../../img/szatnia/Galeria6.jpg";
import image3 from "../../../img/szatnia/Galeria3.jpg";
import image4 from "../../../img/szatnia/Galeria4.jpg";
import image5 from "../../../img/szatnia/Galeria5.jpg";
import image6 from "../../../img/szatnia/Galeria2.jpg";

import image7 from "../../../img/szatnia/pionowe1.jpg";
import image8 from "../../../img/szatnia/pionowe2.jpg";
import image9 from "../../../img/szatnia/pionowe3.jpg";
import image10 from "../../../img/szatnia/poziome1.jpg";
import image11 from "../../../img/szatnia/poziome2.jpg";
import image12 from "../../../img/szatnia/poziome3.jpg";
const images = [
  image5,
  image3,
  image6,
  image4,
  image2,
  image1,
  image9,
  image10,
  image11,
  image12,
  image7,
  image8
];

export default class Galery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      imagePadding: 100
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <section id="galery" className="py-3">
        <div className="container p-5">
          <h1 className="text-center">GALERIA</h1>
          <p className="text-center">Nasze szatnie</p>
          <div className="row m-3 justify-content-around">
            <div className="col-md-4">
              <img
                src={image5}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 0 })}
              />
            </div>
            <div className="col-md-4">
              <img
                src={image3}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 1 })}
              />
            </div>
            <div className="col-md-4">
              <img
                src={image6}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 2 })}
              />
            </div>
          </div>
          <div className="row m-3 justify-content-around">
            <div className="col-md-4">
              <img
                src={image4}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 3 })}
              />
            </div>
            <div className="col-md-4">
              <img
                src={image2}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 4 })}
              />
            </div>
            <div className="col-md-4">
              <img
                src={image1}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 5 })}
              />
            </div>
          </div>
          <div className="row m-3 justify-content-around">
            <div className="col-md-4">
              <img
                src={image9}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 6 })}
              />
            </div>
            <div className="col-md-4">
              <img
                src={image10}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 7 })}
              />
            </div>
            <div className="col-md-4">
              <img
                src={image11}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 8 })}
              />
            </div>
          </div>
          <div className="row m-3 justify-content-around">
            <div className="col-md-4">
              <img
                src={image12}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 9 })}
              />
            </div>
            <div className="col-md-4">
              <img
                src={image7}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 10 })}
              />
            </div>
            <div className="col-md-4">
              <img
                src={image8}
                alt=""
                className="img-fluid p-1 border border-dark rounded"
                onClick={() => this.setState({ isOpen: true, photoIndex: 11 })}
              />
            </div>
          </div>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cloackroom/Galery/Galery.js